var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"56b8b8b800d712c58181535ef8e26e31ee769f77"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web@grailed"]={id:"56b8b8b800d712c58181535ef8e26e31ee769f77"};
      